import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ProductAction, AlertAction, AuthAction } from '../../actions';
import { RayForm, RayFormValidation } from '../common';
import { EditSaveCancelBar } from '../common/Buttons';
import { useBatchEdit } from '../../hooks/useBatchEdit';
import { DeviceModels } from '../../config/RayCodes';
import { useTranslation } from 'react-i18next';

const toDraft = (p) => ({ model: p?.model, option: p?.option });

// 펼친 행 하나의 편집. 행마다 key 로 새로 만들어져 행을 바꾸거나 닫으면 편집 중이던 값은 버려진다.
const ProductRowEdit = ({ product, UpdateProductInfo, editable, showsn, cancelcallback }) => {
	const [t] = useTranslation();
	const isAdmin = location.pathname.toLowerCase().startsWith('/admin/');
	const { draft, editing, saving, errors, formKey, onChange, onEdit, onSave, onCancel } = useBatchEdit({
		source: product,
		toDraft,
		save: (changed) => UpdateProductInfo(product._id, changed),
		editable: !!editable,
		entry: 'header',
		onClose: cancelcallback
	});

	const form_controls = [
		{
			title: '',
			items: [
				{
					type: 'input',
					name: 'sn',
					label: t('product.field.sn'),
					val: product.sn,
					viewLinkPath: isAdmin ? "/Admin/AdminProductInfo/" : "/Product/",
					required: true
				},
				{
					type: 'select',
					name: 'model',
					label: t('product.field.model'),
					val: draft.model,
					list: DeviceModels,
					required: true,
					isEditable: editing,
				},
				{
					type: 'input',
					name: 'option',
					label: t('common.label.option'),
					val: draft.option,
					isEditable: editing,
				},
				{ type: 'input', name: 'installedDate', label: t('installation.field.installDate'), val: product.installedDate, valtype: 'date' },
				{
					type: 'input',
					name: 'lastConnectedDate',
					label: t('product.label.lastConnect'),
					val: product.lastConnectedDate,
					valtype: 'date',
					isEditable: false,   // SEC-015: 서버(EMS) 관리 읽기 필드 — 클라이언트 편집 불가
				},
				{ type: 'input', name: 'registered', label: t('common.status.registered'), val: product.registered, valtype: 'date', isEditable: false /* SEC-015: 등록일 읽기 필드 */ }
			]
		},
	];

	const controls = (!editable && !showsn)
		? [{ title: "", items: form_controls[0].items.filter(x => x.name != "sn") }]
		: form_controls;

	return (
		<>
			<RayForm key={formKey} controls={controls} handleChangeData={onChange} errors={errors} nocard={true} />
			<div className="ps-1 pe-1 pb-1">
				<EditSaveCancelBar
					canEdit={!!editable}
					editing={editing}
					onEdit={onEdit}
					onSave={() => onSave(form_controls)}
					onCancel={onCancel}
					saving={saving} />
			</div>
		</>
	);
};

const ProductInfo = ({ prd, productInfos, UpdateProductInfo, editable, showsn = false, cancelcallback = null }) => {
	const [selectedId, setSelectedId] = useState(null);

	// 열린 행은 한 번에 하나뿐이다. 같은 행을 다시 누르면 닫는다.
	const setItem = (x) => setSelectedId(prev => (prev == x._id ? null : x._id));

	return (
		<div className="section inset">
			{productInfos?.map(x => {
				return (
					<div className="accordion mt-1" key={x._id}>
						<h2 className="accordion-header">
							<button className="accordion-button" onClick={() => setItem(x)}>
								<strong>
									{x.sn} <small> {x.model} / {x.option}</small>
								</strong>
							</button>
						</h2>
						{selectedId == x._id && (
							<ProductRowEdit
								key={x._id}
								product={x}
								UpdateProductInfo={UpdateProductInfo}
								editable={editable}
								showsn={showsn}
								cancelcallback={cancelcallback} />
						)}
					</div>
				)
			})}
		</div>
	)
};

const mapState = (state) => {
	const prd = state.ProductReducer.product;
	return { prd };
};

const mapDispatch = (dispatch) => ({
	UpdateProductInfo: (_id, data) => dispatch(ProductAction.UpdateProductInfo(_id, data)),
});

export default connect(mapState, mapDispatch)(ProductInfo);
